import { render, staticRenderFns } from "./CookieAcceptDecline.vue?vue&type=template&id=b25730d8&"
import script from "./CookieAcceptDecline.vue?vue&type=script&lang=js&"
export * from "./CookieAcceptDecline.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports